<template>
  <div class="footer">
      <h4>Copyright &copy; 2021. All Rights Reserved</h4>
  </div>  
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>
.footer{
   background-color: var(--ternary);
   height: 40px; 
    font-family: Segoe UI;   
}
.footer h4{
   color: white;
   padding: 10px;
   margin: 0 20px;
}
</style>